export default [
    '/dashboard',
    '/orders',
    '/orders/assigned',
    '/orders/completed',
    '/quotes/create',
    '/quotes/edit'
];